export const PLAY_MARKET =
  'https://play.google.com/store/apps/details?id=com.hera';
export const APP_STORE = 'https://apps.apple.com/us/app/playhera/id1449021935';
